<template lang="pug">
  yz-dialog(v-model="showDialog" max-width="500px" persistent scrollable)
    yz-card
      yz-dialog-normal-header(title="Edit claim amount" @close="onCloseDialog")
      yz-dialog-normal-content.px-6.py-6
        .yz-regular-body-sm.text-neutral-700.mb-6 The updated claim amount will be saved and reflected in the invoice. Remarks are optional and will be logged if provided.

        v-form(ref="form" v-model="isFormValid")
          .mb-4
            .yz-medium-body-sm.text-neutral-700.mb-1 New claim amount
            yz-text-field(v-model.number="newClaimAmount" :prefix="$currency.symbol" type="number" step="1" required, :rules="amountRules")

          .mb-4
            .d-flex.justify-space-between.align-center.mb-2
              .yz-medium-body-sm.text-neutral-500 Current claim amount
              .yz-medium-body-sm.text-neutral-700.text-right {{ currentAmount | displayPrice($currency) }}
            .d-flex.justify-space-between.align-center
              .yz-medium-body-sm.text-neutral-500 Adjustments
              .yz-medium-body-sm.text-right(:class="adjustmentColor") {{ adjustmentAmount | displayPrice($currency) }}

          .mb-4
            .yz-medium-body-sm.text-neutral-700.mb-1 Remarks (optional)
            yz-textarea(v-model="remarks" placeholder="Enter remarks here" rows="4")

      yz-dialog-normal-actions(save-label="Confirm" cancel-label="Cancel" :loading="isLoading" :disable-save="isConfirmDisabled" @save="onConfirmEdit" @cancel="onCloseDialog")
</template>

<script>
import { validateDecimalPlaces } from '@/utils'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    currentAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isLoading: false,
      isFormValid: false,
      newClaimAmount: null,
      remarks: '',
      amountRules: [
        v => parseFloat(v) > 0 || 'Amount must be greater than 0',
        v => {
          const newAmountInCents = Math.round(parseFloat(v) * this.$currency.multiplier)
          return newAmountInCents !== this.currentAmount || 'New amount must be different from current amount'
        },
        v => validateDecimalPlaces(v, this.$currency)
      ]
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    newAmountInCents() {
      if (!this.newClaimAmount || isNaN(parseFloat(this.newClaimAmount))) {
        return 0
      }
      return Math.round(this.newClaimAmount * this.$currency.multiplier)
    },
    adjustmentAmount() {
      if (!this.newClaimAmount) {
        return 0
      }

      const current = this.currentAmount
      const adjustment = this.newAmountInCents - current
      return Math.abs(adjustment).toFixed(2)
    },
    adjustmentColor() {
      if (!this.newClaimAmount || this.newClaimAmount === 0) {
        return 'text-neutral-700'
      }

      const current = this.currentAmount
      if (this.newAmountInCents > current) {
        return 'text-success-500'
      } else if (this.newAmountInCents < current) {
        return 'text-danger-500'
      }
      return 'text-neutral-700'
    },
    isConfirmDisabled() {
      return !this.isFormValid || this.newClaimAmount == null || parseFloat(this.newClaimAmount) <= 0
    }
  },
  methods: {
    onCloseDialog() {
      this.$emit('input', false)
    },
    onConfirmEdit() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.$emit('confirmed', this.newAmountInCents, this.remarks)
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped></style>
